import { logger } from '@lusha/client-logger';
import { communicator } from 'lusha-widgets';
import reportClientEvent from './reportClientEvent';
const onCorePluginBIEvent = payload => {
    switch (payload.type) {
        case 'SCOUT_SETTINGS_CHANGED': {
            const { scoutEnabled } = payload.data;
            if (scoutEnabled) {
                reportClientEvent({
                    eventType: 'plugin_permission_accepted_clicked',
                });
            }
            reportClientEvent({
                eventType: 'plugin_menu_enable_b2b_websites_clicked',
                eventValue: scoutEnabled ? 'on' : 'off',
            });
            break;
        }
        default:
            logger.warn('Unknown core plugin event received, this should not happen');
            break;
    }
};
export const listenCorePluginBIEvents = () => {
    communicator.getMessenger('CORE_PLUGIN_BI_EVENT', { listen: true }, onCorePluginBIEvent);
};
